import { Drawer } from '@material-ui/core';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../../Styles/NavBar/NavBar.css';

const NavBar = () => {
    const [menuDrawer, setMenuDrawer] = useState(false);

    return (
        <div className="navbar-main-container flex-box">
            <Link to="/">
                <img className="main-logo" src={process.env.PUBLIC_URL + `./main-logo.png`} alt="logo" />
            </Link>
            <header className="header-main-container flex-box">
                <Link to="/">Home</Link>
                <Link to="/about">About</Link>
                <Link to="/projects">Projects</Link>
                <Link to="/blog">Blogs</Link>
                <Link to="/contact">Contact</Link>
                <Link className="flex-box" rel="noopener noreferrer" target="_blank" to={process.env.PUBLIC_URL + '/PDF/Resume.pdf'} download>
                    <i className="fa fa-download"></i>
                    <span>Resume</span>
                </Link>
            </header>
            <div className="navbar-burger-icon-container flex-box" onClick={() => setMenuDrawer(true)}>
                <i className="fa fa-bars" aria-hidden="true"></i>
            </div>
            <div className="menu-items-container flex-box">
                <Drawer anchor="right" open={menuDrawer} onClick={() => setMenuDrawer(false)}>
                    <div className="drawer-main-logo flex-box">
                        <img className="main-logo" src={process.env.PUBLIC_URL + `./main-logo.png`} alt="logo" />
                    </div>
                    <Link className="menu-item" to="/">Home</Link>
                    <Link className="menu-item" to="/about">About</Link>
                    <Link className="menu-item" to="/projects">Projects</Link>
                    <Link className="menu-item" to="/blog">Blogs</Link>
                    <Link className="menu-item" to="/contact">Contact</Link>
                    <Link className="menu-item flex-box" rel="noopener noreferrer" target="_blank" to={process.env.PUBLIC_URL + '/PDF/Resume.pdf'} download>
                        <i className="fa fa-download"></i>
                        <span>Resume</span>
                    </Link>
                </Drawer>
            </div>
        </div>
    )
}

export default NavBar
